module.exports = __webpack_public_path__ + "59f8d1f8e15c0ad142c00082f5ef6380.png";